import { z } from 'zod';

const optionalUrl = z
  .string()
  .trim()
  .optional()
  .or(z.literal(''))
  .refine((value) => !value || /^https?:\/\/.+/i.test(value), {
    message: 'Enter a valid URL starting with http:// or https://'
  });

export const projectDetailsSchema = z.object({
  service: z.string().min(1, 'Please select a service'),
  projectType: z.string().min(1, 'Please select a project type'),
  budget: z.string().min(1, 'Please select an estimated budget'),
  timeline: z.string().min(1, 'Please select a timeline'),
  description: z
    .string()
    .trim()
    .min(20, 'Please share at least 20 characters about your project')
    .max(2000, 'Keep the description under 2000 characters'),
  referenceUrl: optionalUrl
});

export const contactInfoSchema = z.object({
  name: z.string().trim().min(2, 'Name is required'),
  company: z.string().trim().min(1, 'Company / brand name is required'),
  email: z.string().trim().email('Enter a valid email address'),
  phone: z
    .string()
    .trim()
    .min(7, 'Enter a valid phone number')
    .max(20, 'Phone number is too long'),
  country: z.string().trim().min(2, 'Country is required'),
  preferredCommunication: z.string().min(1, 'Select a preferred channel'),
  website: optionalUrl
});

export const meetingScheduleSchema = z.object({
  timezone: z.string().min(1, 'Select a timezone'),
  preferredDate: z.string().min(1, 'Select a preferred date'),
  preferredTime: z.string().min(1, 'Select a preferred time'),
  meetingDuration: z.string().min(1, 'Select a meeting duration'),
  meetingPurpose: z.string().min(1, 'Select a meeting purpose')
});

export const consultationSchema = projectDetailsSchema
  .merge(contactInfoSchema)
  .merge(meetingScheduleSchema);

export const stepSchemas = {
  1: projectDetailsSchema,
  2: contactInfoSchema,
  3: meetingScheduleSchema,
  4: consultationSchema
};

export const stepFields = {
  1: ['service', 'projectType', 'budget', 'timeline', 'description', 'referenceUrl'],
  2: ['name', 'company', 'email', 'phone', 'country', 'preferredCommunication', 'website'],
  3: ['timezone', 'preferredDate', 'preferredTime', 'meetingDuration', 'meetingPurpose'],
  4: []
};
